import { takeLatest, take, put, select, call } from 'redux-saga/effects';
import queryString from 'query-string';
// import { push } from 'connected-react-router';

// actions
import { setAPIInProgress, signIn } from 'store/actions/authActions';
import * as storage from 'utils/storage';
import Api from 'api/auth';
import { getUserDataFromAccessToken } from 'store/sagas/auth/authSagas';

// storage helpers functions

export function persistToken({
  accessToken,
  refreshToken,
}: {
  accessToken?: any;
  refreshToken?: any;
}) {
  storage.setStorageType(storage.LOCAL_STORAGE);
  if (accessToken) {
    storage.setStorageItem('accessToken', JSON.stringify(accessToken));
  }
  if (refreshToken) {
    storage.setStorageItem('refreshToken', JSON.stringify(refreshToken));
  }
}

export function* getRedirectPath() {
  const query = yield select(({ router }) =>
    queryString.parse(router.location.search, { arrayFormat: 'bracket' }),
  );
  return query?.next;
}

export function* ensureSignIn({ payload }) {
  try {
    yield put({ type: setAPIInProgress.type, payload: true });
    const {
      data: { jwt_token },
    } = yield call(Api.signIn, { data: JSON.stringify(payload) });

    yield call(persistToken, { accessToken: jwt_token });
    yield call(getUserDataFromAccessToken, { accessToken: jwt_token });
    yield put({ type: setAPIInProgress.type, payload: false });
  } catch (err) {
    yield put({ type: setAPIInProgress.type, payload: false });
    yield put({
      type: signIn.failure,
      err,
    });
  }
}

export function* watchSignIn() {
  yield takeLatest(signIn.type, ensureSignIn);
  yield take(signIn.success);
}
